import { Routes, Route } from "react-router-dom"
import { Toaster, ToastBar, toast } from "react-hot-toast"
import { Analytics } from "@vercel/analytics/react"

import { ROUTES } from "./constants"
import { useScrollToTop } from "./hooks"

// Layout
import { Main } from "./pages/Main/Main"
import { ModalBase } from "./components/modals/ModalBase/ModalBase"

// Public pages
import { Landing } from "./pages/Landing/Landing"
import { PeruAI } from "./pages/PeruAI/PeruAI"
import { Blog } from "./pages/Blog/Blog"
import { About } from "./pages/About/About"
import { Privacy } from "./pages/Privacy/Privacy"
import { Terms } from "./pages/Terms/Terms"
import { NotFound } from "./pages/NotFound/NotFound"

// Protected pages
import { Profile } from "./pages/Profile/Profile"
import { ProtectedRoute } from "./components/features/ProtectedRoute/ProtectedRoute"

// Auth pages
import { Login } from "./pages/auth/Login/Login"
import { Register } from "./pages/auth/Register/Register"
import { VerifyEmail } from "./pages/auth/VerifyEmail/VerifyEmail"
import { ForgotPassword } from "./pages/auth/ForgotPassword/ForgotPassword"
import { ChangePassword } from "./pages/auth/ChangePassword/ChangePassword"
import { SEO } from "./components/features/SEO"

import './App.css'

function App() {
    // The new AuthStore no longer needs initialization as it
    // checks token validity on creation
    useScrollToTop();

    return (
        <div className="App">
            <Analytics />
            <SEO />
            <ModalBase />
            <Toaster
                position="top-center"
                toastOptions={{
                    duration: 5000,
                    success: { className: "toast-success" },
                    error: { className: "toast-error" },
                    style: {
                        zIndex: 20
                    }
                }}
                children={(toasts) => (
                    <ToastBar toast={toasts}>
                        {({ icon, message }) => (
                            <div
                                onClick={() => toast.dismiss()}
                                style={{ cursor: "pointer", display: "flex" }}
                            >
                                {icon}
                                {message}
                            </div>
                        )}
                    </ToastBar>
                )}
            />
            <Routes>
                {/* Info & Legal pages */}
                <Route path={ROUTES.about} element={<About />} />
                <Route path={ROUTES.privacy} element={<Privacy />} />
                <Route path={ROUTES.terms} element={<Terms />} />

                {/* Public auth endpoints */}
                <Route path={ROUTES.login} element={<Login />} />
                <Route path={ROUTES.register} element={<Register />} />
                <Route path={ROUTES.verifyEmail} element={<VerifyEmail />} />
                <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />

                {/* Protected auth endpoints */}
                <Route element={<ProtectedRoute redirectToLogin />}>
                    <Route path={ROUTES.changePassword} element={<ChangePassword />} />
                </Route>

                <Route path={ROUTES.main} element={<Main />}>
                    {/* Public routes */}
                    <Route path={ROUTES.home} element={<Landing />} />
                    <Route path={ROUTES.peruai} element={<PeruAI />} />
                    <Route path={ROUTES.blog} element={<Blog />} />

                    {/* Protected routes - require authentication */}
                    <Route element={<ProtectedRoute />}>
                        <Route path={ROUTES.profile} element={<Profile />} />
                        {/* Add more protected routes here */}
                    </Route>
                </Route>
                <Route path={ROUTES.notFound} element={<NotFound />} />
            </Routes>
        </div>
    )
}

export { App }
